import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import { BasicInformation, ClaimDetails, PricingErrors, ServiceLineItems } from '../Components/Combined/Results';
import { FQHC as modelType } from '../Constants/modelTypes';
import { formatStringAsCurrency, cleanUpNumberString } from '../Utils/stringUtils';
import { useNavigate, useLocation } from 'react-router-dom';
import usePrintOrientation from '../Hooks/usePrintOrientation';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function FQHCResult() {
    const [_orientation, _setOrientation] = usePrintOrientation('landscape');
    const location = useLocation();
    const navigate = useNavigate();
    const { result, calendarYear } = location.state;
    const pricerName = 'Federally Qualified Health Center';
    const processedDate = new Date();

    const handleNavigateToEOBGenerator = () => {
        navigate('/EOB', {
            state: {
                processedDate,
                pricerType: modelType,
                lines: result.lines.map(responseLine => {
                    const medicareAllowedAsFloat = parseFloat(cleanUpNumberString(responseLine.medicareAllowed)) || 0;
                    return {
                        gafApplies: responseLine.GAFApplies || false,
                        lineNumber: responseLine.lineNumber || "",
                        hcpcs: responseLine.HCPCS || "",
                        revCode: responseLine.RevCode || "",
                        billedAmount: parseFloat(cleanUpNumberString(responseLine.billed)) || 0,
                        allowedAmount: medicareAllowedAsFloat,
                        newPatientAdjustmentFactor: parseFloat(cleanUpNumberString(responseLine.newPatientAdjustmentFactor)) || 0,
                        newPatientAdjustmentFactorApplies: responseLine.newPatientAdjustFactorApplies || false
                    }
                })
            }
        })
    }

    return (<div className="py-2">
        <div className="row g-0 sticky top border-bottom">
            <div className="row justify-content-between g-0">
                <div className="col-auto">
                    <PrintButton />
                </div>
                <div className="col-auto">
                    <Protect module={EOB_VIEW} behavior={HIDE} >
                        {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
                    </Protect>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <div className="row my-2 g-0">
                <div className="col">
                    <h2>{pricerName} Pricer - Pricing Outputs</h2>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.totalMedicareAllowed ?? 0)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        <PricingErrors result={result} totalMedicareAllowed={result.totalMedicareAllowed ?? 0} />
        <div className="row my-2">
            <div className="col-md-6">
                <BasicInformation calendarYear={calendarYear} result={result} model={modelType} processedDate={processedDate} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md-6">
                <ClaimDetails result={result} model={modelType} />
            </div>
        </div>
        <div className="page-break-here"></div>
        <div className="row my-2">
            <div className="col">
                <ServiceLineItems result={result} model={modelType} />
            </div>
        </div>
    </div>
    );
}
